import React, { useEffect, useState } from 'react';
// import DialogComp from '../../../../Core/Dialog/DialogComp';
// import { BasicTable, VehicleCheckTable } from './tableCheckcheck';
import { Button, Grid, IconButton, Select, Tooltip, withStyles } from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';
import './vehicleStyle.scss';
import EditIcon from '@material-ui/icons/Edit';
import { Label } from 'recharts';
import AddBoxIcon from '@material-ui/icons/AddBox';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import AddUpdateVehicleSections from './addUpdatevehicleSection';
import { set } from 'lodash';
import { getAllvehiclecheckchecks, getVehicleCheckSection, getVehicleDocsCategory } from '../../../Core/Service/vehicleChecks';
import BreadCrumbs from '../../../Core/Controls/Breadcrumb';
import TabComponent from '../../../Core/Controls/Tabs';
import { SecondaryButton } from '../../../Core/FormInput';
import { VehicleCheckTable } from './tableCheckcheck';
import DialogComp from '../../../Core/Modal/dialogModal';
import CheckSectionModal from './CheckSection/checkSectionModal';
import SimpleAccordion from '../../../Core/Controls/Accordion';
import CopyInspectionTypeModal from './copyInspectionTypeModal';
// import { color } from 'html2canvas/dist/types/css/types/color';

const crumbs = [
    { name: 'Home', path: '/' },
    // { name: 'Vehicle Checks', active: true },
    { name: 'Inspection Checks', active: true }
];

const VehicleCheckCheck = (props) => {
    const [state, setState] = useState({
        checkList: [],
        VehicleCategoryList: [],
        accOpen: false,
        tabs: [],
        inspectionTypeList: [],
        copyToggle: false,
        accHeading: [],
        modalToggle: false,
        expandCollapsedAt: null,
        tabsToggle: false,
        inspectionTypeID: null,
        checkCheckList: []
    });

    useEffect(() => {
        pullcheckData();
        pullData();
    }, []);

    const pullcheckData = async () => {
        try {
            // Fetch both data sets in parallel
            const [categoryRes, sectionRes] = await Promise.all([getVehicleDocsCategory(), getVehicleCheckSection()]);

            // Validate API responses safely
            const categoryList = categoryRes?.data?.list || [];
            const sectionList = sectionRes?.data || [];

            if (!categoryList.length || !sectionList.length) {
                console.warn('Empty data received from API');
            }

            // Accordion data
            const accHeading = sectionList.map((m) => ({
                ...m,
                id: m.inspectionSheetSectionTypeID,
                heading: m.inspectionSheetSectionDescription,
                checkID: m.inspectionSheetSectionID,
                sectionVehicleCategoryIDs: m.sectionVehicleCategoryIDs,
                inspectionSheetSectionSeprator: m.inspectionSheetSectionSeprator
            }));

            console.log(accHeading, 'sectionList');

            // Tabs data
            const tabs = categoryList.map((item) => ({
                id: item.id,
                label: item.name,
                // isSeperator: item.inspectionSheetSectionSeprator,
                accData: accHeading.filter((data) => data.id === item.id).sort((a, b) => a.inspectionSheetSectionPosition - b.inspectionSheetSectionPosition)
            }));

            // Add "Add Section" button tab
            tabs.push({
                id: null,
                label: <AddBoxIcon color="secondary" onClick={handleSection} style={{ cursor: 'pointer' }} />,
                accData: []
            });

            // Copy an existing inspection check into a new one
            tabs.push({
                id: null,
                label: (
                    <Tooltip title="Copy Inspection Check">
                        <FileCopyIcon color="secondary" onClick={handleCopyOpen} style={{ cursor: 'pointer', fontSize: 20 }} />
                    </Tooltip>
                ),
                accData: []
            });

            // Update state safely
            setState((st) => ({
                ...st,
                accHeading,
                tabs,
                // Same list that drives the tabs, reused by the copy dropdown
                inspectionTypeList: categoryList.map((c) => ({ id: c.id, name: c.name }))
            }));
        } catch (error) {
            console.error('Error in pullcheckData:', error);

            // Optional: show fallback UI message
            setState((st) => ({
                ...st,
                accHeading: [],
                tabs: [],
                error: 'Failed to load inspection data. Please try again later.'
            }));
        }
    };

    const pullData = async () => {
        try {
            let res = await getAllvehiclecheckchecks();
            setState((st) => ({
                ...st,
                checkCheckList: res?.data?.list || []
            }));
        } catch (error) {
            console.warn(error);
        }
    };

    const closeDialog = (res) => {
        setState((state) => ({ ...state, modalToggle: false, tabsToggle: false }));
        res && pullcheckData();
        res && pullData();
    };

    const handleExpand = (value) => {
        setState((state) => ({
            ...state,
            expandCollapsedAt: new Date(),
            accOpen: value
        }));
    };
    const addCheckSections = (tabID, id) => {
        setState((st) => ({
            ...st,

            modalToggle: true,
            sectionID: id,
            tabID: tabID
        }));
        handleExpand(false);
    };

    const handleSection = (val) => {
        setState((st) => ({ ...st, tabsToggle: true, inspectionTypeID: val?.id }));
    };

    const handleCopyOpen = () => {
        setState((st) => ({ ...st, copyToggle: true }));
    };

    const handleCopyClose = (copied) => {
        setState((st) => ({ ...st, copyToggle: false }));
        if (copied) {
            // Reload so the new inspection check appears as a tab
            pullcheckData();
            pullData();
        }
    };

    const title = `${!state.sectionID ? 'Add' : 'Update'} Check Section`;

    console.log(state.tabs, 'ddddddddddddddddd');

    const checkChecks = state.tabs.map((tab, index) => {
        const heading = tab.accData.map((o) => o.heading);
        // const isSeperator = tab.accData.map((o) => o.inspectionSheetSectionSeprator);
        // let isSeperator= tab.accData
        const filterAccordion = tab.accData.filter((o, index) => !heading.includes(o.heading, index + 1));
        // console.log(tab.accData, 'acc');
        return {
            label: (
                <div>
                    {tab.id ? (
                        <span style={{ display: 'flex', justifyContent: 'space-around', padding: 0, alignItems: 'center' }}>
                            <IconButton onClick={() => handleSection(tab)}>
                                <EditIcon style={{ color: '#f50057', fontSize: 15 }} size="small" />
                            </IconButton>
                            {tab.label}
                        </span>
                    ) : (
                        tab.label
                    )}
                </div>
            ),
            body: (
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Grid container justifyContent="flex-start">
                            {/* {!isSeperator && ( */}
                            <Grid item style={{ marginTop: 10 }}>
                                <SecondaryButton
                                    variant="contained"
                                    style={{ width: 'auto', padding: '4px 10px', fontWeight: 800, textTransform: 'capitalize' }}
                                    color="primary"
                                    onClick={() => addCheckSections(tab.id)}
                                >
                                    + Add Section
                                </SecondaryButton>
                            </Grid>
                            {/* )} */}
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        {filterAccordion.map((ad) => (
                            <SimpleAccordion
                                key={ad.checkID}
                                isSeperator={ad.inspectionSheetSectionSeprator}
                                style={{ background: ad.inspectionSheetSectionSeprator ? 'grey' : '' }}
                                header={
                                    <div style={{ fontWeight: 700, color: ad.inspectionSheetSectionSeprator ? 'white' : '#f50057' }}>
                                        <IconButton onClick={() => addCheckSections(tab.id, ad.checkID)}>
                                            <EditIcon style={{ color: ad.inspectionSheetSectionSeprator ? 'white' : '#f50057', fontSize: 20 }} size="small" />
                                        </IconButton>
                                        {ad.heading}{' '}
                                    </div>
                                }
                                changedAt={state.expandCollapsedAt}
                                Expand={ad.inspectionSheetSectionSeprator ? false : state.accOpen}
                            >
                                <VehicleCheckTable
                                    checksMainID={ad.id}
                                    checksID={ad.checkID}
                                    accName={ad.heading}
                                    List={state.checkCheckList}
                                    pullData={pullData}
                                    isSeperator={ad.inspectionSheetSectionSeprator}
                                    sectionVehicleCategoryIDs={ad.sectionVehicleCategoryIDs}
                                />
                            </SimpleAccordion>
                        ))}
                    </Grid>
                </Grid>
            )
        };
    });

    return (
        <div className="inspectionScreen">
            <Grid container>
                <Grid item xs={12}>
                    <Grid container alignItems="center" justifyContent="space-between">
                        <Grid item xs>
                            <BreadCrumbs crumbs={crumbs} />
                        </Grid>
                        <Grid item>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    handleExpand(true);
                                }}
                                size="small"
                                color="secondary"
                                style={{ textTransform: 'capitalize' }}
                            >
                                Expand All
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    handleExpand(false);
                                }}
                                size="small"
                                color="secondary"
                                style={{ marginLeft: 2, textTransform: 'capitalize' }}
                            >
                                Collapse All
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs>
                    <TabComponent tabList={checkChecks} id="check_check" selectedIndex={0} overflow={'none'} />
                </Grid>

                {state.modalToggle ? (
                    <DialogComp title={title} onClose={() => closeDialog(false)}>
                        <CheckSectionModal onClose={() => closeDialog(true)} checkSectionID={state.sectionID} tabID={state.tabID} />
                    </DialogComp>
                ) : null}

                {state.tabsToggle ? (
                    <DialogComp
                        title={state.inspectionTypeID ? 'Update Inspection Type' : 'Add Inspection Type'}
                        onClose={() => closeDialog(false)}
                        maxWidth={'md'}
                        fullWidth
                    >
                        <AddUpdateVehicleSections InspectionTypeID={state.inspectionTypeID} onClose={() => closeDialog(true)} />
                    </DialogComp>
                ) : null}

                {state.copyToggle ? (
                    <DialogComp title="Copy Inspection Check" onClose={() => handleCopyClose(false)} maxWidth={'xs'} fullWidth>
                        <CopyInspectionTypeModal typeList={state.inspectionTypeList} onClose={handleCopyClose} />
                    </DialogComp>
                ) : null}
            </Grid>
        </div>
    );
};

export default VehicleCheckCheck;
